import { useTranslation } from "react-i18next";
import BarChart from "../charts/barChart";

const LeadServiceInsightsBarChart = ({ data }) => {
  const { t } = useTranslation();
  return (
    <BarChart
      distributed
      columnWidth={"25%"}
      height={"400px"}
      isStrokeVisible
      colors={[
        "#808080",
        "#008ffbd9",
        "#dc3545",
        "#dc3545",
        "#dc3545",
        "#dc3545",
        "#dc3545",
        "#20c997"
      ]}
      series={[
        {
          data: [
            data.total,
            data.open || 0,
            data.nameWrong || 0,
            data.numberWrong || 0,
            data.notReached || 0,
            // data.notSuitable || 0,
            data.notSuitableDueToCallResult || 0,
            data.notSuitableDueToAccessibility || 0,
            data.suitable || 0
          ],
          name: "Count"
        }
      ]}
      categories={[
        t("funnelInsights.leadService.total"),
        t("funnelInsights.leadService.open"),
        t("funnelInsights.leadService.nameWrong"),
        t("funnelInsights.leadService.numberWrong"),
        t("funnelInsights.leadService.notReached"),
        // t("funnelInsights.leadService.notSuitable"),
        t("funnelInsights.leadService.notSuitableDueToCallResult"),
        t("funnelInsights.leadService.notSuitableDueToAccessibility"),
        t("funnelInsights.leadService.suitable")
      ]}
      xaxisLabelStyles={{
        trim: true,
        rotate: 0,
        hideOverlappingLabels: false
      }}
    />
  );
};
export default LeadServiceInsightsBarChart;
